import * as i0 from '@angular/core';
import * as i1 from './app.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/material/table';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.MatTable<any> = (<any>(null as any));
var _decl0_12:i3.MatHeaderCellDef = (<any>(null as any));
var _decl0_13:i3.MatHeaderRowDef = (<any>(null as any));
var _decl0_14:i3.MatColumnDef = (<any>(null as any));
var _decl0_15:i3.MatCellDef = (<any>(null as any));
var _decl0_16:i3.MatRowDef<any> = (<any>(null as any));
var _decl0_17:i3.MatFooterCellDef = (<any>(null as any));
var _decl0_18:i3.MatFooterRowDef = (<any>(null as any));
var _decl0_19:i3.MatHeaderCell = (<any>(null as any));
var _decl0_20:i3.MatCell = (<any>(null as any));
var _decl0_21:i3.MatFooterCell = (<any>(null as any));
var _decl0_22:i3.MatHeaderRow = (<any>(null as any));
var _decl0_23:i3.MatRow = (<any>(null as any));
var _decl0_24:i3.MatFooterRow = (<any>(null as any));
var _decl0_25:i2.AsyncPipe = (<any>(null as any));
var _decl0_26:i2.UpperCasePipe = (<any>(null as any));
var _decl0_27:i2.LowerCasePipe = (<any>(null as any));
var _decl0_28:i2.JsonPipe = (<any>(null as any));
var _decl0_29:i2.SlicePipe = (<any>(null as any));
var _decl0_30:i2.DecimalPipe = (<any>(null as any));
var _decl0_31:i2.PercentPipe = (<any>(null as any));
var _decl0_32:i2.TitleCasePipe = (<any>(null as any));
var _decl0_33:i2.CurrencyPipe = (<any>(null as any));
var _decl0_34:i2.DatePipe = (<any>(null as any));
var _decl0_35:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_36:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_37:i2.KeyValuePipe = (<any>(null as any));
var _decl0_38:i2.CommonModule = (<any>(null as any));
var _decl0_39:i3.MatTableModule = (<any>(null as any));
var _decl0_40:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_41:i0.ElementRef<any> = (<any>(null as any));
